import { defineStore } from 'pinia'
import router from '@/router'
import { store } from '@/store'

export const useGlobalStore = defineStore('global', {
  state: () => {
    return {
      fontSize: localStorage.getItem('fontsize') || 14,
      AIVisible: false,
      dicts: {
        statusEnum: {
          1: '交底初核',
          2: '深度评审'
        }
      },
      sendAIChat: '',
      quoteAIChat: null,
    }
  },
  getters: {
    getFontSizr(state) {
      return state.fontSize;
    },
  },
  actions: {
    setSendAIChat(str) {
      this.sendAIChat = str
    },
    setQuoteAIChat(info) {
      this.quoteAIChat = info
    },
    setFontSize(fontSize) {
      this.fontSize = fontSize
      localStorage.setItem('fontsize', fontSize)
    },
    setAIVisible(flag) {
      this.AIVisible = flag
    }
  },
  persist: true
})

export function useGlobalStoreWithOut() {
  return useGlobalStore(store);
}
